
<template lang="html">
    <div class="details">
        <div class="details_model" v-html="datas">
            {{datas}}
        </div>
    </div>
</template>

<script>
    import {bbc2html} from '@/utils/bbcode'
    export default {
        data(){
            return {
                act : [],
                datas: ''
            }
        },
        mounted(){
            this.$http({
                url: '/activity/detail',
                method: 'get',
                params: {
                    activity_id : this.$route.query.id,
                },
            }).then( (res) => {
                this.$http({
                    url: "/Post/details",
                    method: 'get',
                    params: {
                        start: '0',
                        limit: '1',
                        topicid: res.data.tid,
                    },
                }).then( (res) => {
                    this.datas = bbc2html(res.data[0].message);
                })
            })

        },

        methods:{
            bbc2html: bbc2html
        }
    }
</script>

<style lang="css" scoped>
.details_model{
    box-sizing: border-box;
    padding-top: 20px;
    line-height: 25px;
    font-size: 14px;
}

.details_model /deep/ img{
    width: 100%;
    object-fit: cover;
    margin: auto;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}
</style>
